module.exports = __webpack_public_path__ + "media/images/default/shared/footer/line-294b701f822b862534a3185f2233ccf3.svg";